import { Checkbox } from 'evergreen-ui';
import React, { useState } from 'react';

// Sample permissions data
const initialPermissions = [
  { resource: 'dues', fullAccess: false, queryAccess: true, mutationAccess: false },
  { resource: 'communication', fullAccess: false, queryAccess: true, mutationAccess: false },
  { resource: 'complaints', fullAccess: false, queryAccess: true, mutationAccess: false },
  { resource: 'owners', fullAccess: false, queryAccess: true, mutationAccess: false },
  { resource: 'residents', fullAccess: false, queryAccess: true, mutationAccess: false },
  { resource: 'security', fullAccess: false, queryAccess: true, mutationAccess: false },
  { resource: 'properties', fullAccess: false, queryAccess: true, mutationAccess: false },
  { resource: 'visitation', fullAccess: false, queryAccess: true, mutationAccess: false },
];

function PermissionsList({ onPermissionsChange }) {
  const [permissions, setPermissions] = useState(initialPermissions);

  // Update permissions and call the callback whenever permissions change
  const handlePermissionChange = (index, field, checked) => {
    const updatedPermissions = permissions.map((perm, i) =>
      i === index
        ? {
            ...perm,
            [field]: checked,
            // If fullAccess is selected, set query and mutation access as well
            ...(field === 'fullAccess' && { queryAccess: checked, mutationAccess: checked }),
            // Reset fullAccess if queryAccess or mutationAccess is individually modified
            ...(field !== 'fullAccess' && { fullAccess: checked && perm.mutationAccess && perm.queryAccess }),
          }
        : perm
    );

    setPermissions(updatedPermissions);
    onPermissionsChange(updatedPermissions); // Send updated permissions to parent
  };

  return (
    <div>
      {permissions.map((perm, index) => (
        <div key={perm.resource} style={{ marginBottom: '10px', padding: '10px', border: '1px solid #ddd', borderRadius: '8px' }}>
          <h4>{perm.resource.charAt(0).toUpperCase() + perm.resource.slice(1)}</h4>

          <Checkbox
            checked={perm.fullAccess}
            onChange={(e) => handlePermissionChange(index, 'fullAccess', e.target.checked)}
            label="Full Access"
          />
          <Checkbox
            checked={perm.queryAccess}
            onChange={(e) => handlePermissionChange(index, 'queryAccess', e.target.checked)}
            label="View Only"
          />
          <Checkbox
            checked={perm.mutationAccess}
            onChange={(e) => handlePermissionChange(index, 'mutationAccess', e.target.checked)}
            label="Create and Edit"
          />
        </div>
      ))}
    </div>
  );
}



export default PermissionsList;
